<template>
  <div
    class="text-center items-center py-1 text-white bg-pale-sky rounded-lg shadow-md flex gap-2 justify-center"
  >
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatistics'"
    >
      {{ $t("expertStatisticsNavigation.origins_title") }}
      {{ urlType === "queue" ? "PAR FILE" : "PAR UTILISATEUR" }}
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsAnsweredDaily'"
    >
      {{ $t("expertStatisticsNavigation.answeredUnansweredCallsDaily") }}
      {{ urlType === "queue" ? "PAR FILE" : "PAR UTILISATEUR" }}*
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsAnsweredUnanswered'"
    >
      <!-- {{ $t("expertStatisticsNavigation.answeredUnansweredCalls") }} -->
      KPI
      {{ urlType === "queue" ? "PAR FILE" : "PAR UTILISATEUR" }}
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsAnsweredUnansweredWeekYear'"
    >
      {{ $t("expertStatisticsNavigation.answeredUnansweredCalls") }} -
      <span class="text-lg italic">
        {{ $t("answeredUnansweredCallsWeekYear") }}
      </span>
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsAnsweredUnansweredWeekDay'"
    >
      {{ $t("expertStatisticsNavigation.answeredUnansweredCalls") }} -
      <span class="text-lg italic">
        {{ $t("answeredUnansweredCallsWeekDay") }}
      </span>
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsOriginDetail'"
    >
      {{ $t("expertStatisticsNavigation.originsTop10") }}
      {{ urlType === "queue" ? "PAR FILE" : "PAR UTILISATEUR" }}
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsReportList'"
    >
      {{ $t("expertStatisticsNavigation.reportList") }}
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsCallerNumbers'"
    >
      {{ $t("expertStatisticsNavigation.callerNumbers") }}
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsDIDReport'"
    >
      Rapport {{ $t("didReport") }}
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsThirdPartyNumber'"
    >
      {{ $t("expertStatisticsNavigation.thirdPartyNumber") }}
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsOutbound'"
    >
      {{ $t("expertStatisticsNavigation.overview") }}
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsOutboundAnswered'"
    >
      {{ $t("expertStatisticsNavigation.answeredUnansweredCalls") }}
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsOutboundDuration'"
    >
      {{ $t("expertStatisticsNavigation.durations") }}
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsOutboundPbx'"
    >
      {{ $t("expertStatisticsNavigation.pbx") }}
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsOutboundTrunk'"
    >
      {{ $t("expertStatisticsNavigation.trunk") }}
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="
        $route.name === 'ExpertStatisticsFullExtensionReport' ||
          $route.name === 'ExpertStatisticsUserReport'
      "
    >
      RAPPORT DÉTAILLÉ PAR UTILISATEUR
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="$route.name === 'ExpertStatisticsCallerNumbersReport'"
    >
      RAPPORT DÉTAILLÉ PAR GROUPE DE APPELANT
    </h2>
    <h2
      class="uppercase text-lg font-bold mb-"
      v-if="
        this.$route.name === 'ExpertStatisticsFullQueueReport' ||
          this.$route.name === 'ExpertStatisticsQueueDetail'
      "
    >
      Rapport {{ $t("queueDetail") }}
      <span class="text-xl text-gray-800" v-if="selectedQueue">
        -
        <span v-for="(queue, idx) in selectedQueue" :key="queue">
          {{ queue
          }}<span v-show="idx < selectedQueue.length - 1" class="mr-1">,</span>
        </span>
        <!-- <span v-if="pbxMapData">{{
                 pbxMapData.call_queues[selectedQueue].name
               }}</span> -->
      </span>
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsQueueComparator'"
    >
      {{ $t("queueComparison") }}
      <span v-if="compareElement && compareElement.length > 0">
        - {{ compareElement[1] }} {{ $t("compareTo") }}
        {{ compareElement[0] }}
        <!-- <span v-if="pbxMapData">{{
                 pbxMapData.call_queues[selectedQueue].name
               }}</span> -->
      </span>
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="this.$route.name === 'ExpertStatisticsTRTC'"
    >
      {{ $t("didCallers") }}
      <!-- <span v-if="selectedQueue">
               - {{ selectedQueue }}
               
             </span> -->
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="
        this.$route.name === 'ExpertStatisticsGroups' &&
          this.$route.path.includes('did')
      "
    >
      {{ $t("groupsNumbers") }}
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="
        this.$route.name === 'ExpertStatisticsGroups' &&
          this.$route.path.includes('queue')
      "
    >
      {{ $t("groupsQueues") }}
    </h2>
    <h2
      class="uppercase text-lg font-bold"
      v-if="
        this.$route.name === 'ExpertStatisticsGroups' &&
          this.$route.path.includes('extension')
      "
    >
      {{ $t("groupsExtensions") }}
    </h2>
    <h2 v-if="reportData?.name" class="uppercase text-lg font-bold">
      - {{ reportData?.name }}
    </h2>
  </div>

  <Loading
    v-model:active="isLoading"
    :can-cancel="true"
    :on-cancel="onCancel"
    :is-full-page="fullPage"
  />
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapGetters } from "vuex";
import QuickSearch from "../QuickSearch.vue";
import { ChevronDownIcon } from "@heroicons/vue/solid";
import SearchFilter from "../SearchFilter.vue";

const account = localStorage.getItem("account");

const hostContext = [
  { name: "callQueue", id: 0, value: "queue" },
  { name: "extension", id: 1, value: "extension" },
];

const reports = ["report 1", "report 2", "report 3"];

export default {
  props: [
    "selectHostname",
    "parseDateRange",
    "buttonSelected",
    "parseTimeRange",
    "periodSelector",
    "timeSelected",
    "urlType",
    "pbxMenuType",
    "elementToRemove",
    "elements",
    "buttonTitle",
    "selectedQueue",
    "compareElement",
    "reportData",
    "selections",
  ],
  components: {
    QuickSearch,
    ChevronDownIcon,
    SearchFilter,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      reports,
      hostContext,
      selectReport: this.$t("reportList"),
      search: "",
      closeForm: false,
      account,
      enabled: false,
      selectHostName: null,
      selectHostContext: "",
      clearAllElements: false,
      elementListConcatReduce: [],
      elementGroupsExtensionList: [],
      elementGroupsQueueList: [],
      extensionsList: [],
      queueList: [],
      clearAllElements: true,
      selectAllElements: false,
      selectedAllElements: false,
      pbxMapData: {},
    };
  },
  methods: {
    setHostTimeZone(zone) {
      let date = new Date(`August 19, 1975 12:00:00 ${zone}`);
      let utcHourOffset = 12 - date.getUTCHours();
      localStorage.setItem("hostTimeZone", utcHourOffset + 1);
    },
    getTimeZoneByHost(host) {
      let timeZones = {
        "encomconseil.3cx.fr": "GMT+02:00",
        "demo-encom.3cx.fr": "GMT+02:00",
        "plus-voyages.3cx.fr": "GMT+02:00",
        "tdaconseil.my3cx.fr": "GMT+02:00",
      };
      if (host) {
        if (timeZones[host]) {
          return timeZones[host];
        } else {
          return "GMT+02:00";
        }
      } else {
        return "GMT+02:00";
      }
    },
  },
  mounted() {
    this.selectHostContext = this.$store.state.hostContext;
    this.selectHostName = this.hostName;
  },
  computed: {
    ...mapGetters([
      "buttonSelector",
      "hostName",
      "hostNames",
      "groupSelected",
      "groupSelectedName",
    ]),
  },
  watch: {
    search: function(val) {
      this.$emit("update:search", val);
    },
    selectHostName: function(val) {
      this.$emit("select-hostname", val);
      this.$store.dispatch("hostName", val);
      localStorage.setItem("hostName", val);
      this.setHostTimeZone(this.getTimeZoneByHost(val));
      // this.concatArray();
    },
    selectHostContext: function(val) {
      localStorage.setItem("hostContext", val);
      this.$store.dispatch("hostContext", val);
      this.$emit("select-hostContext", val);
    },
  },
};
</script>

<style scoped>
.route_table_header {
  padding: 10px 40px 10px 40px;
}
.select {
  padding-right: 0.5rem;
}
</style>
